var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-row",
    {
      staticClass: "yxt-user-selector-container yxt-user-multi-container",
      attrs: { type: "flex" },
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-user-search-wrap" },
        [
          _c("yxt-input", {
            staticClass: "keyword",
            staticStyle: { width: "240px" },
            attrs: {
              size: "small",
              placeholder: _vm.$t("biz_udp_enter_rolename"),
              searchable: "",
            },
            on: {
              search: function ($event) {
                return _vm.getRoleData(true)
              },
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.getRoleData(true)
              },
            },
            model: {
              value: _vm.params.keyWords,
              callback: function ($$v) {
                _vm.$set(_vm.params, "keyWords", $$v)
              },
              expression: "params.keyWords",
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: _vm.refTable,
          staticClass: "mt16 yxt-user-table",
          staticStyle: { width: "100%" },
          attrs: { height: _vm.tableHeight, "row-key": "id", data: _vm.role },
          on: { select: _vm.selectRole, "select-all": _vm.selectAllRole },
        },
        [
          _vm.multiple
            ? _c("yxt-table-column", {
                attrs: {
                  "show-overflow-tooltip": false,
                  "class-name": "yxtbiz-table-selection",
                  type: "selection",
                  width: "42",
                  "reserve-selection": "",
                  "clear-padding": "right",
                },
              })
            : _c("yxt-table-column", {
                attrs: { "show-overflow-tooltip": false, width: "40" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("yxt-radio", {
                          attrs: { label: scope.row.id },
                          on: {
                            change: function ($event) {
                              return _vm.selectRole(scope.row.id, scope.row)
                            },
                          },
                          model: {
                            value: _vm.singleSelect,
                            callback: function ($$v) {
                              _vm.singleSelect = $$v
                            },
                            expression: "singleSelect",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
          _vm.multiple
            ? _c(
                "yxt-table-column",
                {
                  attrs: {
                    width: "18",
                    align: "right",
                    "clear-padding": "left-right",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "yxt-dropdown",
                        {
                          attrs: { placement: "bottom-start" },
                          on: { command: _vm.tableHeaderCommand },
                        },
                        [
                          _c("span"),
                          _c(
                            "yxt-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "yxt-dropdown-item",
                                { attrs: { command: "selectCurrent" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$t("pc_biz_enroll_select_current_page")
                                        .d("选择本页")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "yxt-dropdown-item",
                                { attrs: { command: "selectAll" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$t("pc_biz_enroll_select_all")
                                        .d("选择全部")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "yxt-dropdown-item",
                                { attrs: { command: "clearSelect" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$t("pc_biz_enroll_clear_all")
                                        .d("清空所选")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _c("yxt-table-column", {
            attrs: {
              prop: "name",
              "show-overflow-tooltip": "",
              label: _vm.$t("biz_udp_role"),
              "min-width": "180",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "remark",
              label: _vm.$t("pc_biz_udp_lbl_description"),
              "min-width": "180",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              prop: "userCount",
              label: _vm.$t("pc_biz_udp_lbl_userCount"),
              align: "right",
            },
          }),
          _c("template", { slot: "empty" }, [
            _c(
              "div",
              { staticStyle: { "line-height": "normal" } },
              [_c("yxt-empty")],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "yxt-row",
        {
          staticClass: "yxtbiz-user-selector-mask mt16",
          attrs: { type: "flex", align: "middle" },
        },
        [
          _c("yxt-row", {
            staticClass: "col-flex-1",
            attrs: { type: "flex", align: "middle" },
          }),
          _c("yxt-pagination", {
            staticClass: "pages",
            attrs: {
              small: "",
              "page-size": _vm.params.limit,
              "page-sizes": [5, 10, 20, 30, 50, 100],
              "current-page": _vm.currentPage,
              layout: "total, prev, pager, next",
              total: _vm.total,
              "simple-total": "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }